import MArArrow from './m-ar-arrow';

export default MArArrow;